// extracted by mini-css-extract-plugin
export default {"select":"SeriesSelect-module__select--CmgyM","animatedBackground":"SeriesSelect-module__animatedBackground--QTLfK"};